import { render, staticRenderFns } from "./ProjectPagination.vue?vue&type=template&id=4a2b5194&scoped=true&"
import script from "./ProjectPagination.vue?vue&type=script&lang=js&"
export * from "./ProjectPagination.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPagination.vue?vue&type=style&index=0&id=4a2b5194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b5194",
  null
  
)

export default component.exports